import React from 'react';
import { Link } from 'gatsby';
import { alterName } from '../utils';

export default function ItemPreview({
  data: { name, type, rarity, description, recipe },
}) {
  return (
    <Link to={`/${alterName(name, true)}`} className="itemPreview">
      {name ? (
        <>
          <img
            src={`/${alterName(name)}.png`}
            alt={name}
            width="32"
            height="32"
          />
          <h3 className="itemPreview-name">{name}</h3>
        </>
      ) : (
        ''
      )}
      {description ? (
        <p className="itemPreview-description">{description}</p>
      ) : (
        ''
      )}
      {type ? <span className="itemPreview-type"><Link to={`/type/${alterName(type, true)}`}>{type}</Link></span> : ''}
      {rarity ? <span className="itemPreview-rarity"><Link to={`/rarity/${rarity}`}>{rarity}</Link></span> : ''}
      {recipe?.length === 2 ? (
        <div className="itemPreview-recipe">{`${recipe[0]} + ${recipe[1]}`}</div>
      ) : (
        ''
      )}
    </Link>
  );
}
